<template>
  <picture :title="person?.name ?? ''">
    <source
      v-for="(source, index) in sources"
      :key="index"
      type="image/webp"
      v-lazy-load :data-srcset="source.srcset"
      :media="source.media"
      :data-not-lazy="notLazy"
      :fetchpriority="fetchPriority"
      @error="onError"
    />

    <img
      ref="img"
      class="block object-cover"
      :width="width"
      :height="height"
      v-lazy-load :data-src="fallbackPicture"
      :alt="alt"
      :data-not-lazy="notLazy"
      @error="onError"
    />
  </picture>
</template>

<script>
import { useContext } from "@nuxtjs/composition-api";
import { ref } from "vue";
import defaultAvatar from "~/assets/default-avatar.png";

export default {
  props: {
    person: {
      type: Object,
      required: true,
    },
    alt: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "100%",
    },
    width: {
      type: String,
      default: "100%",
    },
    notLazy: {
      type: Boolean,
      default: false,
    },
    fetchPriority: {
      type: String,
      default: "auto",
    },
  },
  setup(props) {
    const { $helpers } = useContext();

    const sourceWidths = [448, 336, 256, 192];
    const minWidths = [900, 400, 300, null];
    const sources = ref([]);
    const fallbackPicture = ref(defaultAvatar);

    if (props.person?.profilePhotoId) {
      sources.value = sourceWidths.map((size, index) => ({
        srcset: $helpers.getProfilePictureThumbnailUrl(props.person.profilePhotoId, size, "webp"),
        media: minWidths[index] ? `(min-width: ${minWidths[index]}px)` : "",
      }));
      fallbackPicture.value = $helpers.getProfilePictureThumbnailUrl(props.person.profilePhotoId, 256, "jpg");
    }

    const onError = (event) => {
      sources.value = [];
      fallbackPicture.value = defaultAvatar;
      console.error("Image load error:", event);
    };

    return {
      sources,
      fallbackPicture,
      onError,
    };
  },
};
</script>
